import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('.swiper')
  if (!swiperEl) return

  const swiper = new Swiper(swiperEl, {
    modules: [Navigation, Pagination],
    a11y: true,
    spaceBetween: 20,
    slidesPerView: 1.2,
    loop: false,
    simulateTouch: true,
    navigation: {
      nextEl: '.swiper-arrows .right',
      prevEl: '.swiper-arrows .left',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 1.5,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
      },
    },
  })

  swiper.slideToLoop(0, 0)
})
